enum BuildingViewVariant {
  ListView,
  MapView,
}

namespace BuildingViewVariant {
  export function getTextLabelKey(variant: BuildingViewVariant) {
    switch (variant) {
      case BuildingViewVariant.ListView:
        return 'Navbar_ListView';
      case BuildingViewVariant.MapView:
        return 'Navbar_MapView';
    }
  }
}

export default BuildingViewVariant;
